import { render, staticRenderFns } from "./RecapitulationOfVATTable.vue?vue&type=template&id=48780ef6&"
import script from "./RecapitulationOfVATTable.vue?vue&type=script&lang=js&"
export * from "./RecapitulationOfVATTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports